import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=57ad6261&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "materialize-css/dist/css/materialize.min.css?vue&type=style&index=0&id=57ad6261&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=57ad6261&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad6261",
  null
  
)

export default component.exports